import LoadingIcon from "components/Loading/LoadingIcon";
import { useCallback, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { useGetRreTinByIdQuery } from "services/rre-api";
import RREPageContainer from "./RREPageContainer";
import RRETinForm from "./RRETinForm";
import { usePatchRreTinMutation } from "services/rre-api";
import { KaboodleToaster } from "components/common";

const RRETinPage = () => {
  const { rreTinId } = useParams<{ rreTinId?: string }>();
  const prevRreTinIdRef = useRef(rreTinId);

  const { data: rreTin, isFetching } = useGetRreTinByIdQuery(
    { id: rreTinId },
    { skip: !rreTinId, refetchOnMountOrArgChange: true },
  );

  const [patchRreTinById] = usePatchRreTinMutation();

  // show loading icon when we're fetching AND switching TINs
  const isNavigating =
    (isFetching && prevRreTinIdRef.current !== rreTinId) ||
    (rreTinId && rreTin?.id.toString() !== rreTinId);

  useEffect(() => {
    prevRreTinIdRef.current = rreTinId;
  }, [rreTinId]);

  const handleSave = useCallback(
    async (field: string, value: unknown) => {
      if (rreTinId) {
        try {
          await patchRreTinById({
            id: rreTinId,
            data: { [field]: value },
          }).unwrap();
        } catch (error) {
          console.error("Error saving RRE Tin:", error);
          KaboodleToaster.error("Failed to save RRE Tin data");
        }
      }
    },
    [patchRreTinById, rreTinId],
  );

  if (!rreTinId || !rreTin) {
    return null;
  }

  if (isNavigating) {
    return (
      <div className="flex jc-c ai-c h-100">
        <LoadingIcon />
      </div>
    );
  }

  return (
    <RREPageContainer>
      <RRETinForm rreTin={rreTin} onSave={handleSave} />
    </RREPageContainer>
  );
};

export default RRETinPage;
